import {GET, POST} from "../util";

const inspectionUrl = "api/exchange-receivables-inspection";
const operationUrl = "api/exchange-receivables-operation";

const url = {
	inspection: {
		accounts: `${inspectionUrl}/buy-accounts`,
		listAuctions: `${inspectionUrl}/list-auctions/:accountId`,
		getCreditInsurancePolicyHolderStatus: `${inspectionUrl}/tci/status`
	},
	operation: {
		placeBids: `${operationUrl}/place-bids`,
		saveNote: `${operationUrl}/save-note`,
	}
};

const exchangeReceivablesApi = {
	inspection: {
		getBuyAccounts: () => {
			return GET(url.inspection.accounts);
		},
		listAuctions: (accountId, params = {}) => {
			return POST(url.inspection.listAuctions.replace(":accountId", accountId), params);
		},
		getCreditInsurancePolicyHolderStatus: () => {
			return GET(url.inspection.getCreditInsurancePolicyHolderStatus);
		}
	},
	operation: {
		placeBids: (params = {}) => {
			return POST(url.operation.placeBids, params, 'application/json', 'Array');
		},
		saveNote: (params = {}) => {
			return POST(url.operation.saveNote, params, 'application/json');
		},
	}
};

export {exchangeReceivablesApi};
